export interface Article {
  id: string;
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  author: string;
  date: string;
  coverImage: string;
  excerpt: string;
  content: string;
  tags: string[];
  views: number;
  likes: number;
  featured: boolean;
}

export interface Category {
  name: string;
  slug: string;
  description: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  {
    name: '火影同人漫画',
    slug: 'manhua',
    description: '精选火影忍者同人漫画作品，涵盖短篇、连载、四格等多种形式，展现粉丝们对忍者世界的无限想象。',
    icon: 'ri-pages-line',
    count: 128,
  },
  {
    name: '火影同人小说',
    slug: 'xiaoshuo',
    description: '火影忍者同人小说创作合集，包含长篇连载、短篇故事、AU设定等丰富体裁。',
    icon: 'ri-book-open-line',
    count: 256,
  },
  {
    name: '火影同人画集',
    slug: 'huaji',
    description: '高质量火影同人插画、CG集、设定集，汇集国内外优秀画师的火影二次创作作品。',
    icon: 'ri-image-line',
    count: 89,
  },
  {
    name: '火影CP同人',
    slug: 'cp',
    description: '火影忍者CP向同人创作专区，涵盖佐鸣、卡伊、带卡等热门CP的漫画与小说作品。',
    icon: 'ri-heart-line',
    count: 312,
  },
  {
    name: '同人活动资讯',
    slug: 'huodong',
    description: '国内外火影同人展会、线上活动、合志企划等最新资讯与参与指南。',
    icon: 'ri-calendar-event-line',
    count: 45,
  },
];

export const articles: Article[] = [
  {
    id: '1',
    title: '《木叶秘闻录》——佐鸣向长篇同人漫画推荐',
    slug: 'muye-miwenlu-zuoming',
    category: '火影同人漫画',
    categorySlug: 'manhua',
    author: '风间忍',
    date: '2026-07-28',
    coverImage: 'https://readdy.ai/api/search-image?query=Naruto%20and%20Sasuke%20doujinshi%20manga%20style%20illustration%2C%20warm%20orange%20and%20red%20tones%2C%20Japanese%20anime%20art%20style%2C%20soft%20lighting%2C%20emotional%20scene%20with%20cherry%20blossoms%2C%20clean%20composition%20on%20warm%20cream%20background&width=800&height=500&seq=article-cover-1&orientation=landscape',
    excerpt: '这部佐鸣向长篇同人漫画以战后木叶为背景，细腻描绘了鸣人与佐助之间从敌对到理解的情感转变。画风精致，分镜流畅，是同人漫画中不可多得的佳作。',
    content: `<p>在火影忍者同人创作的浩瀚星海中，《木叶秘闻录》无疑是一颗格外耀眼的明星。这部以佐鸣（佐助×鸣人）为主线的长篇同人漫画，自2025年开始连载以来，便以其细腻的情感刻画和精美的画风征服了无数同人爱好者的心。</p>

<h2>故事背景</h2>
<p>故事设定在第四次忍界大战结束后的第三年。木叶村正在重建，鸣人作为未来的火影候选人，每日忙于政务和学习。而佐助则选择了一条独自游历、暗中守护木叶的道路。两人虽各自前行，命运却始终交织在一起。</p>

<h2>创作亮点</h2>
<p>作者风间忍的画风深受岸本齐史影响，但又融入了自己独特的细腻风格。人物表情丰富传神，尤其是鸣人那双湛蓝的眼眸中流露出的情感，令人过目难忘。背景绘制同样一丝不苟，木叶村的街景、终末之谷的壮丽，都展现得淋漓尽致。</p>

<p>剧情方面，作者巧妙地将官方设定与原创情节融合。既不违背原作精神，又给了读者全新的阅读体验。佐助逐渐打开心扉的过程写得极为自然，没有生硬的转折，每一个情感节点都经过精心铺垫。</p>

<h2>读者评价</h2>
<p>在同人圈内，《木叶秘闻录》收获了极高的评价。许多读者表示"这才是佐鸣关系的正确打开方式"，更有粉丝将其誉为"同人漫画界的标杆之作"。截至目前，该作品的总阅读量已突破50万次。</p>

<h2>推荐理由</h2>
<p>如果你喜欢细腻的情感描写、精美的画面表现，以及对火影世界观的深度挖掘，那么《木叶秘闻录》绝对值得一读。它不仅是一部优秀的同人作品，更是对火影忍者这部经典漫画的深情致敬。</p>`,
    tags: ['佐鸣', '长篇', '战后', '木叶', '情感'],
    views: 52800,
    likes: 4320,
    featured: true,
  },
  {
    id: '2',
    title: '《忍界浮世绘》——火影同人画集鉴赏',
    slug: 'renjie-fushihui-huaji',
    category: '火影同人画集',
    categorySlug: 'huaji',
    author: '墨染千寻',
    date: '2026-07-25',
    coverImage: 'https://readdy.ai/api/search-image?query=Naruto%20characters%20art%20collection%20illustration%20book%20cover%2C%20traditional%20Japanese%20ink%20painting%20style%20mixed%20with%20anime%2C%20warm%20amber%20and%20crimson%20tones%2C%20elegant%20composition%20with%20floating%20leaves%2C%20soft%20gradient%20background&width=800&height=500&seq=article-cover-2&orientation=landscape',
    excerpt: '墨染千寻老师的最新火影同人画集，以浮世绘风格重新诠释火影经典角色，每一幅都是可以裱起来挂在墙上的艺术品。',
    content: `<p>当火影忍者遇上浮世绘，会碰撞出怎样的火花？墨染千寻老师用这本《忍界浮世绘》给出了令人惊艳的答案。这本同人画集收录了50余幅以浮世绘风格绘制的火影角色插画，每一幅都堪称艺术品级别的创作。</p>

<h2>画集概览</h2>
<p>《忍界浮世绘》分为五大篇章：忍者之神篇、晓之章、木叶十二忍、传说三忍以及火影列传。每个篇章都以独特的浮世绘构图和配色方案呈现，既有传统浮世绘的韵味，又不失现代审美的精致。</p>

<h2>艺术特色</h2>
<p>墨染千寻老师擅长将浮世绘的传统技法与数码绘画技术相结合。线条流畅而富有韵律感，色彩以朱红、靛蓝、金箔色为主调，营造出浓郁的日式古典氛围。特别值得一提的是，每幅画作都配有简短的和歌题词，为画面增添了文学意蕴。</p>

<h2>亮点推荐</h2>
<p>画集中最为人称道的是"晓之章"系列——佩恩六道以六幅独立的浮世绘风格呈现，每幅画中的佩恩都融入了日本传统神话元素，创意十足。而鼬与佐助的兄弟对决场景则以屏风绘的形式展现，气势恢宏。</p>

<h2>收藏价值</h2>
<p>这本画集采用精装硬壳工艺，内页使用特种纸印刷，完美还原了原画的色彩与细节。首版限量1000册，每本均附有作者亲笔签名的收藏证书，对于火影同人爱好者来说，是一份不可多得的收藏珍品。</p>`,
    tags: ['画集', '浮世绘', '插画', '收藏', '艺术'],
    views: 38900,
    likes: 5100,
    featured: true,
  },
  {
    id: '3',
    title: '《六代目的日常》——卡卡西中心向同人小说',
    slug: 'liudaimu-richang-kakaxi',
    category: '火影同人小说',
    categorySlug: 'xiaoshuo',
    author: '旗木家的小鱼',
    date: '2026-07-20',
    coverImage: 'https://readdy.ai/api/search-image?query=Kakashi%20Hatake%20reading%20a%20book%20in%20Hokage%20office%2C%20warm%20sunlight%20through%20window%2C%20anime%20art%20style%2C%20cozy%20atmosphere%2C%20warm%20amber%20lighting%2C%20wooden%20desk%20with%20scrolls&width=800&height=500&seq=article-cover-3&orientation=landscape',
    excerpt: '以六代目火影旗木卡卡西的日常为切入点，用轻松幽默的笔触描绘了战后木叶的温馨故事。',
    content: `<p>旗木卡卡西——这位永远蒙着面、手持《亲热天堂》的天才忍者，在成为第六代火影之后，他的日常又会是怎样的呢？《六代目的日常》以轻松诙谐的笔调，为我们揭开了这位"摸鱼火影"的办公室日常。</p>

<h2>作品简介</h2>
<p>故事时间线设定在卡卡西继任火影的第一年。没有了战争的威胁，木叶村迎来了和平发展时期。然而，对于习惯了自由散漫生活的卡卡西来说，火影办公室里堆积如山的文件简直就是最可怕的噩梦。</p>

<h2>人物刻画</h2>
<p>作者旗木家的小鱼对卡卡西的性格把握得极为精准。表面慵懒实则睿智、关键时刻从不掉链子——这样的卡卡西形象跃然纸上。而迈特凯作为卡卡西的"永远的对手兼挚友"，在文中的互动更是笑料百出。</p>

<p>值得一提的是，作者对配角群像的刻画同样用心。静音作为火影秘书的抓狂日常、伊鲁卡时不时送来的自制便当、大和无奈的"目击者报告"，每一个人物都鲜活而立体。</p>

<h2>读者反响</h2>
<p>小说自连载以来，凭借温暖治愈的基调和高密度的笑点，迅速在读者中获得了极高人气。许多读者评论道："看完一章就能笑一整天"、"这才是卡卡西老师应该有的幸福生活"。</p>`,
    tags: ['卡卡西', '日常', '轻松', '治愈', '战后'],
    views: 42100,
    likes: 3850,
    featured: true,
  },
  {
    id: '4',
    title: '佐鸣CP同人漫画精选——《羁绊之诗》系列',
    slug: 'zuoming-jiban-zhishi',
    category: '火影CP同人',
    categorySlug: 'cp',
    author: '千鸟与螺旋丸',
    date: '2026-07-18',
    coverImage: 'https://readdy.ai/api/search-image?query=Naruto%20and%20Sasuke%20holding%20hands%20under%20cherry%20blossom%20tree%2C%20romantic%20anime%20art%20style%2C%20soft%20pink%20and%20warm%20orange%20tones%2C%20dreamy%20atmosphere%2C%20petals%20falling%2C%20beautiful%20sunset%20lighting&width=800&height=500&seq=article-cover-4&orientation=landscape',
    excerpt: '佐鸣CP经典同人漫画系列《羁绊之诗》全解析，从最初的相遇、分离到最终的和解，用画笔重述了这对羁绊最深的关系。',
    content: `<p>在火影忍者浩如烟海的同人创作中，佐鸣（佐助×鸣人）无疑是最具人气的CP之一。而《羁绊之诗》系列，则是这一CP同人漫画中绕不开的经典之作。</p>

<h2>系列概述</h2>
<p>《羁绊之诗》由同人社团"千鸟与螺旋丸"历时三年创作完成，共分为七章，分别对应佐鸣关系的七个重要阶段：初遇、竞争、离别、追寻、重逢、并肩、永恒。每一章都以一个关键的情感节点为核心，用细腻的笔触和富有诗意的画面讲述两人的故事。</p>

<h2>创作风格</h2>
<p>作者团队的画风介于岸本齐史原作风与唯美少女漫画风之间，既有忍者世界的硬朗质感，又有CP向作品特有的浪漫氛围。人物比例精准，表情刻画传神，尤其是情感爆发场景中的眼神描绘，堪称一绝。</p>

<h2>影响力</h2>
<p>在同人圈内，《羁绊之诗》系列的影响力可谓巨大。它不仅在国内外漫展上多次获奖，还被翻译成多国语言在海外同人平台上传播。许多同人创作者都表示，自己的创作灵感正是来源于这部作品。</p>`,
    tags: ['佐鸣', 'CP', '羁绊', '经典', '长篇'],
    views: 61800,
    likes: 7200,
    featured: true,
  },
  {
    id: '5',
    title: '2026年夏季火影同人祭参展指南',
    slug: '2026-xiaji-huoying-tongrenji',
    category: '同人活动资讯',
    categorySlug: 'huodong',
    author: '编辑部',
    date: '2026-07-15',
    coverImage: 'https://readdy.ai/api/search-image?query=Naruto%20doujinshi%20convention%20event%20hall%20with%20booths%20and%20cosplayers%2C%20vibrant%20anime%20convention%20atmosphere%2C%20warm%20lighting%2C%20banners%20and%20posters%2C%20crowded%20but%20organized%20venue&width=800&height=500&seq=article-cover-5&orientation=landscape',
    excerpt: '一年一度的火影同人祭即将在8月开幕！本文为你带来完整的参展攻略，包括摊位申请、交通指南和注意事项。',
    content: `<p>每年夏季最令火影同人爱好者期待的盛会——火影同人祭，2026年度的举办信息终于公布了！本届同人祭将于8月15日至17日在上海世博展览馆举行，规模较往年进一步扩大。</p>

<h2>活动概要</h2>
<p><strong>时间：</strong>2026年8月15日（周五）至17日（周日），每日9:30-17:00</p>
<p><strong>地点：</strong>上海世博展览馆2号馆</p>
<p><strong>预计规模：</strong>500+同人摊位，预计到场人次超3万</p>

<h2>参展申请</h2>
<p>摊位申请已于7月1日正式开放。本届活动分为同人志贩卖区、同人画集展示区和Cosplay表演区三大板块。申请同人志摊位的社团需提供至少一本火影忍者相关的同人作品。</p>

<p>申请截止日期为7月31日，入选结果将于8月5日前通过邮件通知。摊位费用为：标准摊位（1.8m×0.9m）300元/天，双倍摊位500元/天。</p>

<h2>交通指南</h2>
<p>地铁8号线中华艺术宫站3号口出，步行约5分钟即可到达。自驾前来的朋友可将车辆停放在展馆地下停车场（停车费10元/小时，每日封顶60元）。</p>

<h2>注意事项</h2>
<p>1. 请遵守展馆秩序，禁止在非指定区域进行交易活动。</p>
<p>2. Cosplay表演需提前在官方渠道报名，现场不接受临时报名。</p>
<p>3. 禁止携带管制刀具等危险道具入场。</p>
<p>4. 请自觉维护环境卫生，离场时将垃圾带走。</p>`,
    tags: ['活动', '展会', '同人祭', '上海', '攻略'],
    views: 28500,
    likes: 2100,
    featured: false,
  },
  {
    id: '6',
    title: '《九尾之夜》——以九喇嘛视角重塑火影世界',
    slug: 'jiuwei-zhiye-jiuma',
    category: '火影同人小说',
    categorySlug: 'xiaoshuo',
    author: '月下妖狐',
    date: '2026-07-12',
    coverImage: 'https://readdy.ai/api/search-image?query=Nine%20tailed%20fox%20kurama%20in%20moonlight%20with%20Naruto%2C%20mystical%20anime%20atmosphere%2C%20orange%20and%20crimson%20glowing%20chakra%2C%20dark%20blue%20night%20sky%2C%20spiritual%20connection%20scene&width=800&height=500&seq=article-cover-6&orientation=landscape',
    excerpt: '颠覆传统的同人小说设定！从九喇嘛的第一人称视角出发，重新讲述那段被封印在鸣人体内的漫长岁月。',
    content: `<p>如果让九尾——九喇嘛来讲述火影忍者的故事，会是怎样一番光景？同人作者月下妖狐的大胆尝试，为我们打开了一扇全新的窗户。</p>

<h2>独特视角</h2>
<p>《九尾之夜》最引人注目的特色，在于它采用了九喇嘛的第一人称叙述视角。从千年前与六道仙人的渊源，到被封印在人柱力体内的漫长岁月，再到与鸣人从敌对走向理解的心路历程——全部以九喇嘛的口吻娓娓道来。</p>

<h2>叙事手法</h2>
<p>作者的叙事技巧令人赞叹。九喇嘛的"声音"既保留了尾兽的古老与威严，又透着一种被误解千年的孤独与无奈。文中穿插了大量九喇嘛对忍者历史的独特见解，许多观点让人耳目一新。</p>

<p>例如，九喇嘛对千手柱间和宇智波斑的评价："那两个人类，一个用爱囚禁了我，一个用恨奴役了我。但他们都忘了，我不是一件武器，我是一个有思想的生命。"</p>

<h2>情感深度</h2>
<p>最打动人心的，是九喇嘛逐渐接纳鸣人的过程。从最初的轻蔑与愤怒，到后来在鸣人身上看到六道仙人影子时的震撼，再到最终愿意将力量托付给这个"笨蛋小鬼"——每一步的转变都有充分的心理铺垫，读来令人信服且感动。</p>`,
    tags: ['九喇嘛', '九尾', '视角', '创新', '情感'],
    views: 35400,
    likes: 4200,
    featured: false,
  },
  {
    id: '7',
    title: '《晓组织图鉴》——反派角色同人画集精品',
    slug: 'xiao-zuzhi-tujian',
    category: '火影同人画集',
    categorySlug: 'huaji',
    author: '赤砂之蝎工作室',
    date: '2026-07-08',
    coverImage: 'https://readdy.ai/api/search-image?query=Akatsuki%20organization%20members%20standing%20together%20in%20dark%20cloaks%20with%20red%20clouds%2C%20dramatic%20anime%20art%20style%2C%20dark%20background%20with%20crimson%20glow%2C%20powerful%20composition&width=800&height=500&seq=article-cover-7&orientation=landscape',
    excerpt: '聚焦晓组织成员的专属同人画集！每位成员都有独立的篇章，从不同画风角度展现反派的魅力。',
    content: `<p>在火影忍者的反派群像中，晓组织无疑是最具魅力的存在。这本由"赤砂之蝎工作室"出品的《晓组织图鉴》，为每一位晓组织成员都献上了精美的同人插画。</p>

<h2>画集结构</h2>
<p>画集按照晓组织成员的加入顺序编排，从长门（佩恩）和小南开始，到宇智波鼬、干柿鬼鲛、赤砂之蝎、迪达拉、飞段、角都、绝，再到临时成员大蛇丸，每一位都有6-8幅不同风格的插画。</p>

<h2>多风格呈现</h2>
<p>这本画集的一大特色是多画师合作。每位画师都以自己最擅长的风格来诠释晓组织成员：有的采用暗黑哥特风描绘飞段的血腥仪式，有的以水墨风格展现鼬的孤寂背影，还有的用赛博朋克风格重新设计蝎的傀儡装甲。</p>

<h2>特别收录</h2>
<p>画集末尾特别收录了一组"晓组织日常"的四格漫画，描绘了这些S级叛忍在组织内部的搞笑日常。比如飞段和角都因为钱的问题吵架、迪达拉和蝎争论艺术的定义——这些轻松的内容为整本画集增添了别样的趣味。</p>`,
    tags: ['晓组织', '反派', '画集', '多画师', '图鉴'],
    views: 31200,
    likes: 4600,
    featured: true,
  },
  {
    id: '8',
    title: '带卡CP向同人创作十年回顾',
    slug: 'daika-cp-shinian-huigu',
    category: '火影CP同人',
    categorySlug: 'cp',
    author: '神无毗桥的风',
    date: '2026-07-05',
    coverImage: 'https://readdy.ai/api/search-image?query=Obito%20and%20Kakashi%20facing%20each%20other%20in%20Kamui%20dimension%2C%20emotional%20anime%20scene%2C%20warm%20orange%20light%20breaking%20through%20darkness%2C%20powerful%20emotional%20connection%2C%20dramatic%20composition&width=800&height=500&seq=article-cover-8&orientation=landscape',
    excerpt: '带土×卡卡西（带卡）是火影同人圈中经久不衰的热门CP。本文回顾了这一CP十年来的创作演变与经典作品。',
    content: `<p>带土与卡卡西——这对曾经并肩作战的队友，因命运的捉弄而走向截然不同的道路，却始终无法割舍彼此的羁绊。正是这种复杂而深刻的关系，使带卡成为火影同人圈中最具故事张力的CP之一。</p>

<h2>CP起源与发展</h2>
<p>带卡CP的兴起可以追溯到外传《卡卡西外传～战场上的少年时代～》的播出。带土那句"我认为白牙是真正的英雄"以及临终前将写轮眼托付给卡卡西的场景，深深触动了无数观众的心。随着第四次忍界大战篇中带土的再次登场以及最终的救赎，这一CP的人气达到了顶峰。</p>

<h2>创作类型变迁</h2>
<p>早期的带卡同人创作以"外传时期"的少年友情为主，风格偏温馨。随着原作剧情的发展，"面具男"时期的身份揭露催生了大量虐向创作。而大战结束后的"救赎与和解"主题，则成为近年来创作者们最偏爱的方向。</p>

<h2>代表作品推荐</h2>
<p>十年间，带卡同人圈涌现了无数优秀作品。小说方面，《神无毗桥》被誉为带卡文学的"入坑必读"；漫画方面，《万花筒》以其精湛的画风和虐心的剧情成为经典。此外，许多创作者还尝试了音乐PV、手书动画等多媒体形式的同人创作。</p>`,
    tags: ['带卡', '带土', '卡卡西', 'CP', '回顾'],
    views: 45600,
    likes: 5800,
    featured: false,
  },
  {
    id: '9',
    title: '火影同人创作入门：从零开始画你的第一本同人志',
    slug: 'tongren-chuangzuo-rumen',
    category: '火影同人漫画',
    categorySlug: 'manhua',
    author: '编辑部',
    date: '2026-07-01',
    coverImage: 'https://readdy.ai/api/search-image?query=Drawing%20tablet%20and%20sketchbook%20with%20Naruto%20character%20sketches%2C%20warm%20desk%20lamp%20lighting%2C%20creative%20workspace%2C%20manga%20drawing%20tools%2C%20cozy%20art%20studio%20atmosphere&width=800&height=500&seq=article-cover-9&orientation=landscape',
    excerpt: '想要创作属于自己的火影同人志却不知从何下手？这份保姆级入门指南将带你从选题、分镜到印刷，一步步完成你的第一本同人本子。',
    content: `<p>每个火影粉丝心中都有一个属于自己的忍者故事。与其让这些精彩的构想停留在脑海中，不如将它们付诸笔端，创作出属于你自己的火影同人志！本文将从零开始，手把手教你如何完成第一本同人本子的创作。</p>

<h2>第一步：确定选题</h2>
<p>好的选题是同人创作成功的一半。建议从以下几个方面入手：</p>
<p>1. <strong>选择你最熟悉的角色</strong>——对角色理解越深，创作越得心应手。</p>
<p>2. <strong>确定创作类型</strong>——短篇漫画、插图集、四格搞笑还是小说？根据自己的擅长领域来选择。</p>
<p>3. <strong>找到独特的角度</strong>——与其复述原作剧情，不如尝试从新视角切入。</p>

<h2>第二步：准备工具</h2>
<p>数码创作推荐使用Clip Studio Paint（有专门的漫画创作功能）或Procreate搭配iPad。传统手绘则需要准备原稿纸、蘸水笔、墨水、网点纸等工具。</p>

<h2>第三步：分镜设计</h2>
<p>分镜是同人漫画的灵魂。一个好的分镜能够准确传达情节节奏和情感起伏。建议先用简笔画画出大致的分镜草稿（Name），确认整体节奏后再进行精细绘制。</p>

<h2>第四步：印刷与装帧</h2>
<p>完成内页绘制后，就可以考虑印刷了。目前国内同人志印刷服务已经相当成熟。建议选择A5尺寸（148mm×210mm）作为入门尺寸，印刷数量从50-100本起步较为合适。</p>

<h2>第五步：参加展会</h2>
<p>印刷完成后，最好的推广方式就是参加同人展会。可以从小型的地方展会开始，积累经验后再挑战更大的平台。</p>`,
    tags: ['教程', '入门', '创作', '同人志', '印刷'],
    views: 48400,
    likes: 6300,
    featured: true,
  },
  {
    id: '10',
    title: '《火影高校AU》——现代校园背景同人小说推荐',
    slug: 'huoying-gaoxiao-AU',
    category: '火影同人小说',
    categorySlug: 'xiaoshuo',
    author: '木叶学园祭',
    date: '2026-06-28',
    coverImage: 'https://readdy.ai/api/search-image?query=Naruto%20characters%20in%20modern%20high%20school%20uniforms%20walking%20through%20cherry%20blossom%20path%2C%20warm%20spring%20sunlight%2C%20youthful%20anime%20vibe%2C%20bright%20and%20cheerful%20atmosphere&width=800&height=500&seq=article-cover-10&orientation=landscape',
    excerpt: '将火影角色们放入现代高中校园，会擦出怎样的火花？这篇长篇AU同人小说将忍者们的青春物语演绎得淋漓尽致。',
    content: `<p>Alternate Universe（AU，平行宇宙设定）是同人创作中最受欢迎的玩法之一。而将火影角色放入现代高中校园的设定，更是经久不衰的经典。木叶学园祭创作的这篇长篇AU小说，就是其中的佼佼者。</p>

<h2>设定介绍</h2>
<p>故事将木叶村设定为东京近郊的一座小城，木叶高中是当地最有名的学校。鸣人是高二年级的转学生，佐助是全校公认的天才学霸，小樱是学生会主席，卡卡西则是那个永远踩点进教室的懒散班主任。</p>

<p>忍术被巧妙地转化为各种"特长"设定：鸣人的"多重影分身"变成了他同时参加多个社团的超强精力，佐助的"写轮眼"则是对细节的惊人观察力和过目不忘的记忆力。</p>

<h2>剧情亮点</h2>
<p>小说主线围绕木叶高中一年一度的"学园祭"展开。各班需要准备节目参加评比，而鸣人所在的班级在筹备过程中发生了一系列有趣又温馨的故事。与此同时，一条关于校园七大不可思议的暗线也悄然展开。</p>

<h2>阅读体验</h2>
<p>作者对校园生活的描写真实而生动——考试前的抱佛脚、运动会上的热血拼搏、放学后在天台分享的便当——这些熟悉的场景因为火影角色的"出演"而焕发出全新的魅力。即便是没有看过火影原作的读者，也能将其当作一部优秀的校园小说来享受。</p>`,
    tags: ['AU', '校园', '现代', '长篇', '青春'],
    views: 37200,
    likes: 4900,
    featured: false,
  },
  {
    id: '11',
    title: '火影同人音乐PV精选——《风之诗》系列',
    slug: 'huoying-tongren-yinyue-PV',
    category: '同人活动资讯',
    categorySlug: 'huodong',
    author: '音忍社',
    date: '2026-06-22',
    coverImage: 'https://readdy.ai/api/search-image?query=Naruto%20characters%20playing%20musical%20instruments%20on%20stage%2C%20concert%20lighting%20with%20warm%20orange%20and%20amber%20spotlights%2C%20anime%20style%20music%20performance%2C%20energetic%20atmosphere&width=800&height=500&seq=article-cover-11&orientation=landscape',
    excerpt: '音忍社出品的火影同人音乐PV系列《风之诗》，以原创音乐搭配手绘动画，带来视听双重享受。',
    content: `<p>在同人创作的世界里，音乐PV是一种将音乐与动画完美结合的艺术形式。音忍社出品的《风之诗》系列，无疑是火影同人音乐PV领域的标杆之作。</p>

<h2>系列概况</h2>
<p>《风之诗》系列目前已发布五部PV，每部都以火影忍者中的经典场景或角色关系为主题，搭配原创音乐和手绘动画。系列名称取自鸣人的风遁忍术，也象征着同人创作如同风一般自由。</p>

<h2>音乐创作</h2>
<p>音忍社的音乐团队由专业的音乐学院毕业生组成。每首原创曲目都经过精心编曲，既有日式动漫配乐的热血感，又融入了中国传统乐器的独特韵味。主题曲《风之诗》更是被粉丝们誉为"不输官方OST"的佳作。</p>

<h2>动画制作</h2>
<p>PV中的动画部分全部由手绘完成，每秒24帧的高帧率制作，流畅度堪比商业动画。制作团队花费了近两年时间才完成了五部PV的全部制作，可见其用心程度。</p>

<h2>传播影响</h2>
<p>该系列在B站、Niconico等平台的总播放量已突破200万次。许多观众留言表示"被同人创作的质量震惊了"、"这才是同人创作的终极形态"。</p>`,
    tags: ['音乐PV', '原创音乐', '手绘动画', '视听', '多媒体'],
    views: 22800,
    likes: 3400,
    featured: false,
  },
  {
    id: '12',
    title: '《宇智波兄弟》——鼬与佐助同人漫画短篇集',
    slug: 'yuzhibo-xiongdi-duanpianji',
    category: '火影同人漫画',
    categorySlug: 'manhua',
    author: '月读之夜',
    date: '2026-06-18',
    coverImage: 'https://readdy.ai/api/search-image?query=Itachi%20and%20Sasuke%20Uchiha%20as%20children%20sharing%20dango%20under%20tree%2C%20nostalgic%20warm%20anime%20scene%2C%20golden%20sunset%20lighting%2C%20emotional%20brotherly%20moment&width=800&height=500&seq=article-cover-12&orientation=landscape',
    excerpt: '聚焦宇智波鼬与佐助兄弟关系的同人漫画短篇集。从童年温馨到灭族之夜，再到最后的告别，每一篇都催人泪下。',
    content: `<p>鼬与佐助——这对宇智波兄弟的故事，是火影忍者中最令人心碎也最令人动容的篇章之一。同人画师月读之夜以极为细腻的笔触，创作了这部聚焦兄弟情感的同人漫画短篇集。</p>

<h2>短篇一览</h2>
<p>《宇智波兄弟》收录了六个独立短篇：</p>
<p>1. 《三色团子》——幼年佐助缠着哥哥买团子的日常温馨</p>
<p>2. 《手里剑练习》——鼬教佐助投掷手里剑的午后</p>
<p>3. 《月读》——灭族之夜，鼬内心的挣扎</p>
<p>4. 《追踪》——佐助踏上复仇之路的决意</p>
<p>5. 《真相》——得知一切后的佐助</p>
<p>6. 《再见》——第四次忍界大战中鼬的最后告别</p>

<h2>创作特色</h2>
<p>月读之夜的画风极为精致，尤其擅长通过细微的面部表情传达复杂的情感。在《三色团子》中，小佐助吃到甜食时眯起眼睛的满足表情，与多年后在《再见》中看着佐助成长时鼬那个温柔的微笑形成呼应，令人潸然泪下。</p>

<h2>读者反馈</h2>
<p>这本短篇集在读者中引发了强烈共鸣。许多读者表示"每一篇都看哭了"、"这才是宇智波兄弟关系的正确打开方式"。更有读者将其中鼬的名台词"原谅我，佐助，这是最后一次了"的手绘场景设置为手机壁纸。</p>`,
    tags: ['鼬', '佐助', '兄弟', '短篇', '催泪'],
    views: 55400,
    likes: 8100,
    featured: true,
  },
];

export const homepageFAQ = [
  {
    question: '什么是火影同人本子？',
    answer: '火影同人本子是指基于《火影忍者》原作进行的二次创作作品，通常以同人志（同人漫画、同人小说、同人画集）的形式在展会或线上平台发布。同人创作者在原作世界观或角色的基础上，加入自己的创意和解读，创作出全新的故事或艺术作品。',
  },
  {
    question: '如何投稿自己的火影同人作品？',
    answer: '我们欢迎所有火影同人创作者的投稿！请将您的作品（漫画、小说或画集）发送至我们的投稿邮箱，并附上作品简介、作者简介以及至少3张预览图。我们的编辑团队会在7个工作日内完成审核并回复。通过审核的作品将获得首页推荐位和专题报道的机会。',
  },
  {
    question: '火影同人本子可以在哪里购买？',
    answer: '火影同人本子主要通过以下渠道获取：1）各大同人展会（如Comicup、成都CD等）的线下摊位；2）同人作者的个人通贩店铺；3）部分合作的线上同人平台。我们网站也会定期整理推荐优质同人作品的获取方式。',
  },
  {
    question: '同人创作是否涉及版权问题？',
    answer: '同人创作在日本和中国都属于灰色地带。一般来说，小规模的非商业同人创作通常不会被追究。但我们建议同人创作者：1）控制印刷数量在合理范围内；2）明确标注为"同人作品"，不混淆官方产品；3）尊重原作，不进行恶意丑化或商业侵权。如果收到版权方的正式通知，应及时下架相关内容。',
  },
  {
    question: '你们和官方有什么关系吗？',
    answer: '我们是独立的火影同人爱好者社区，与《火影忍者》的版权方（集英社、岸本齐史等）没有任何官方关联。我们的目标是建立一个优质的交流平台，帮助同人创作者和读者发现更多精彩的火影同人内容，促进同人文化的健康发展。',
  },
];

export const testimonials = [
  {
    name: '风间忍',
    role: '同人漫画家',
    content: '感谢这个平台让我的作品被更多火影粉丝看到！编辑团队非常专业，对同人创作的理解和支持让我感受到了家的温暖。',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20male%20manga%20artist%20portrait%2C%20warm%20friendly%20smile%2C%20simple%20clean%20background%2C%20soft%20lighting&width=100&height=100&seq=avatar-1&orientation=squarish',
  },
  {
    name: '墨染千寻',
    role: '同人画师',
    content: '在这里发布的画集获得了超出预期的关注，许多读者通过网站联系到我，甚至接到了商业合作的邀约。真心推荐每一位同人创作者加入！',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20female%20illustrator%20portrait%2C%20gentle%20smile%2C%20traditional%20Japanese%20artist%20vibe%2C%20clean%20simple%20background&width=100&height=100&seq=avatar-2&orientation=squarish',
  },
  {
    name: '旗木家的小鱼',
    role: '同人小说作者',
    content: '作为一个默默写文的透明作者，没想到自己的作品能被这么多人喜欢。网站的推荐机制非常公平，内容质量才是唯一的通行证。',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20young%20writer%20portrait%2C%20holding%20a%20notebook%2C%20warm%20and%20friendly%20expression%2C%20simple%20background&width=100&height=100&seq=avatar-3&orientation=squarish',
  },
];